import React, { useState, useEffect, useRef } from "react";
import logo from '../../images/vanani_logo.svg';
import { Link, useLocation, useNavigate } from "react-router-dom";
import Button from '../Button';

function Navbar() {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [activeSubMenu, setActiveSubMenu] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const dropdownRef = useRef(null);

  const location = useLocation();
  const navigate = useNavigate();

  const toggleDropdown = (e, key) => {
    if (window.innerWidth < 992) {
      e.preventDefault();
      setActiveDropdown((prev) => (prev === key ? null : key));
    }
  };

  const toggleSubMenu = (e, key) => {
    if (window.innerWidth < 992) {
      e.preventDefault();
      setActiveSubMenu((prev) => (prev === key ? null : key));
    }
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeDropdown = () => {
    setActiveDropdown(null);
    setActiveSubMenu(null);
  };

  const handleScroll = (e) => {
    e.preventDefault();
    const targetId = e.target.getAttribute("href").slice(1);
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
    setMobileMenuOpen(false); // Close menu on scroll link click
  };

  const handleLogoClick = () => {
    if (location.pathname === "/") {
      window.scrollTo(0, 0);
    } else {
      navigate("/");
    }
    setMobileMenuOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        closeDropdown();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
    setActiveDropdown(null);
    setActiveSubMenu(null);
  }, [location]);

  return (
    <div className="header_main_wrap">
      <div className="container">
        <div className="inr_header_wrap row align-items-center justify-content-between">
          <div className="col-8 col-lg-3 col-md-3">
            <img
              src={logo}
              alt="Vanani Associated"
              onClick={handleLogoClick}
              style={{ cursor: 'pointer' }}
              className="img-fluid"
            />
          </div>
          <div className="col-4 col-lg-9 col-md-9 text-end">
            <div className="mobile_toggle_btn d-lg-none d-block" onClick={toggleMobileMenu}>
              <i className={mobileMenuOpen ? "fas fa-times" : "fas fa-bars"}></i>
            </div>
            <div ref={dropdownRef} className={`nav_wrapper d-flex justify-content-end align-items-center ${mobileMenuOpen ? 'mobile_open' : ''}`}>
              <ul className="d-flex justify-content-end">
                <li><Link to="/about">About Us</Link></li>
                <li
                  className={`dropdown ${activeDropdown === 'services' ? "active" : ""}`}
                >
                  <Link to="/Services" onClick={(e) => toggleDropdown(e, 'services')}>
                    Services <i className={`fas fa-chevron-down ${activeDropdown === 'services' ? 'rotate-icon' : ''}`} style={{ transition: 'transform 0.3s', transform: activeDropdown === 'services' ? 'rotate(180deg)' : 'rotate(0deg)' }}></i>
                  </Link>
                  <ul className={`first_drop_down ${activeDropdown === 'services' ? "d-block" : ""}`}>
                    <li>
                      <Link to="/incorporation" onClick={(e) => toggleSubMenu(e, 'incorporation')}>
                        Incorporation <i className={`fas fa-chevron-right ${activeSubMenu === 'incorporation' ? 'rotate-icon' : ''}`} style={{ transition: 'transform 0.3s', transform: activeSubMenu === 'incorporation' ? 'rotate(90deg)' : 'rotate(0deg)' }}></i>
                      </Link>
                      <ul className={`second_drop_down ${activeSubMenu === 'incorporation' ? "d-block" : "d-none"}`}>
                        <li><Link to="/sole-proprietorship">Sole Proprietorship</Link></li>
                        <li><Link to="/partnership-firm">Partnership Firm</Link></li>
                        <li><Link to="/limited-liability">Limited Liability Partnership (LLP)</Link></li>
                        <li><Link to="/one-person-company">One Person Company</Link></li>
                        <li><Link to="/private-limited-company">Private Limited Company</Link></li>
                        <li><Link to="/public-limited-company">Public Limited Company</Link></li>
                      </ul>
                    </li>
                    <li><Link to="/accounting">Accounting</Link></li>
                    <li>
                      <Link to="/Taxation" onClick={(e) => toggleSubMenu(e, 'taxation')}>
                        Taxation <i className={`fas fa-chevron-right ${activeSubMenu === 'taxation' ? 'rotate-icon' : ''}`} style={{ transition: 'transform 0.3s', transform: activeSubMenu === 'taxation' ? 'rotate(90deg)' : 'rotate(0deg)' }}></i>
                      </Link>
                      <ul className={`second_drop_down ${activeSubMenu === 'taxation' ? "d-block" : "d-none"}`}>
                        <li><Link to="/direct-tax-services">Direct Tax Services</Link></li>
                        <li><Link to="/indirect-tax-service">Indirect Tax Service</Link></li>
                      </ul>
                    </li>
                    <li><Link to="/specialized_tax-services">Specialized Tax Services</Link></li>
                    <li><Link to="/audit-and-assurance-services">Audit & Assurance</Link></li>
                    <li><Link to="/consultancy-services">Consultancy Service</Link></li>
                    <li><Link to="/coming-soon">Corporate Compliance</Link></li>
                    <li><Link to="/coming-soon">CFO Services</Link></li>
                    <li><Link to="/coming-soon">Outsourcing</Link></li>
                  </ul>
                </li>
                <li className={`dropdown ${activeDropdown === 'industries' ? "active" : ""}`}>
                  <Link to="/" onClick={(e) => toggleDropdown(e, 'industries')}>
                    Industries <i className={`fas fa-chevron-down ${activeDropdown === 'industries' ? 'rotate-icon' : ''}`} style={{ transition: 'transform 0.3s', transform: activeDropdown === 'industries' ? 'rotate(180deg)' : 'rotate(0deg)' }}></i>
                  </Link>
                  <ul className={`first_drop_down ${activeDropdown === 'industries' ? "d-block" : ""}`}>
                    <li><Link to="/coming-soon">Real Estate & Infrastructure</Link></li>
                    <li><Link to="/coming-soon">Manufacturing</Link></li>
                    <li><Link to="/coming-soon">Taxtile</Link></li>
                    <li><Link to="/coming-soon">Engineering & Consultancy</Link></li>
                  </ul>
                </li>
                <li><Link to="/coming-soon">Query</Link></li>
                <li><Link to="/coming-soon">Careers</Link></li>
                <li><Link to="/coming-soon">Blogs</Link></li>
              </ul>
              <div className="right_btn_Wrap">
                <Button to="/contact-us" onClick={() => setMobileMenuOpen(false)}>
                  Contact Us
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}

export default Navbar;
